import { Editor } from 'grapesjs';

export function injectCss(editor: Editor, id: string, css: string): void {
  const document = editor.Canvas.getDocument();

  if (!document) {
    console.warn('Document not found');
    return;
  }

  const existingStyle = document.getElementById(id);

  if (existingStyle) {
    existingStyle.innerHTML = css;
    return;
  }

  const style = document.createElement('style');
  style.innerHTML = css;
  style.id = id;

  document.head.appendChild(style);
}
